import { collection, addDoc, doc, deleteDoc, updateDoc, getDocs } from "firebase/firestore";
import { db } from "../../firebaseConfig";

export const addPartner = async (userId, partnerData) => {
    const ref = collection(db, "users", userId, "partners");

    const { name, myShare } = partnerData;

    return await addDoc(ref, {
        name: name,
        myShare: parseFloat(myShare),
        partnerShare: 100 - parseFloat(myShare),
        withdrawals: [],
        createdAt: new Date()
    });
};

// ✅ FULL DELETE (transactions + partner)
export const deletePartnerWithTransactions = async (userId, partnerId) => {
    const transactionsRef = collection(
        db,
        "users",
        userId,
        "partners",
        partnerId,
        "transactions"
    );

    // 🔥 Step 1: delete all transactions
    const snapshot = await getDocs(transactionsRef);

    const deletePromises = snapshot.docs.map(docSnap =>
        deleteDoc(docSnap.ref)
    );

    await Promise.all(deletePromises);

    // 🔥 Step 2: delete partner document
    const partnerRef = doc(db, "users", userId, "partners", partnerId);
    await deleteDoc(partnerRef);
};


// ✅ EDIT partner name
export const updatePartner = async (userId, partnerId, data) => {
    const ref = doc(db, "users", userId, "partners", partnerId);

    const updatedData = {};

    if (data.name !== undefined) {
        updatedData.name = data.name;
    }

    if (data.myShare !== undefined) {
        const myShare = parseFloat(data.myShare);

        updatedData.myShare = myShare;
        updatedData.partnerShare = 100 - myShare; // 🔥 keep consistency
    }

    await updateDoc(ref, updatedData);
};